import axiosInstance from '../axiosInterceptor/axiosInstance'

const assignPlayerToSeasonTeam = async (orgId, requestData) => {
  const url = `v1/orgs/${orgId}/season-team-players`
  const response = await axiosInstance.post(url, requestData)
  return response?.data
}

export default assignPlayerToSeasonTeam
